export const IsExternalUser = (email: string) => {
  return email.includes('@amplify.ai') ? false : true;
};
